import React, {Component} from 'react';


class LoadingView extends Component {
    render() {
        return (
            <div className="loading-big">
                <div className="spinner">
                  <div className="double-bounce1"></div>
                  <div className="double-bounce2"></div>
                </div>
            </div>
        );
    }
}

export default LoadingView;



/** WEBPACK FOOTER **
 ** ./app/src/components/LoadingView.js
 **/